import React from 'react';
import DateRange from './CustomInputs/DateRange';
import MultiSelect from './CustomInputs/MultiSelect';
import Checkbox from './CustomInputs/Checkbox';
import Select from './CustomInputs/Select';

export const INPUT_TYPE = {
  SELECT: 'SELECT',
  DATE_RANGE: 'DATE_RANGE',
  INPUT: 'INPUT',
  MULTI_SELECT: 'MULTI_SELECT',
  CHECKBOX: 'CHECKBOX',
};

function DynamicInputPicker({ inputType, ...props }) {
  switch (inputType) {
    case INPUT_TYPE.SELECT:
      return <Select {...props} />;
    case INPUT_TYPE.DATE_RANGE:
      return <DateRange {...props} />;
    case INPUT_TYPE.MULTI_SELECT:
      return <MultiSelect {...props} />;
    case INPUT_TYPE.CHECKBOX:
      return <Checkbox {...props} />;
    default:
      return (
        <div className="filter__field">
          <label className="filter__field-label" htmlFor={props.id}>{props.label}</label>
          <input
            id={props.id}
            value={props.value}
            onChange={(e) => props.onChange(e.target.value)}
            {...props.inputAttributes}
          />
        </div>
      );
  }
}

export default DynamicInputPicker;
